export enum TeamSize {
    ALONE = 1,
    TEAM = 2,
}
